import Model, { attr } from '@ember-data/model';
import type { BillingQuotePlanType } from 'uplisting-frontend/models/billing-quote';

export default class CustomerPlanChangeModel extends Model {
  @attr('string') planType!: BillingQuotePlanType;
  @attr('string') planTier!: string;
  @attr('boolean') annual!: boolean;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'customer-plan-change': CustomerPlanChangeModel;
  }
}
